import React, { useState, useRef, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../Utility/API";
import { useNavigate, useParams } from "react-router-dom";
import { Modal, Form, Button } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";

import FormControl from "@mui/material/FormControl";

import "react-datetime-picker/dist/DateTimePicker.css";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";

import moment from "moment/moment";

const CreateCoupon = (props) => {
  const { onClose, editData, open, ...other } = props;
  const [isLoading, setIsLoading] = useState(false);

  const [couponName, setCouponName] = useState("");
  const [description, setDescription] = useState("");
  const [expiryType, setExpiryType] = useState("");
  const [startTime, setStartTime] = useState("");
  const [expiryDays, setExpiryDays] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [amount, setAmount] = useState("");
  const [playerType, setPlayerType] = useState("");
  const [playerCount, setPlayerCount] = useState("");
  const [availableType, setAvailableType] = useState("");
  const [userlist, setUserList] = useState("");
  const [customerIds, setCustomerIds] = useState("");
  const [isActive, setIsActive] = useState(false);
console.log('editData',editData.expiryDate)
  React.useEffect(() => {
    if (open) {
      if (Object.keys(editData).length === 0) {
        setCouponName("");
        setDescription("");
        setExpiryDate("")
        setStartTime("");
        setExpiryType("");
        setExpiryDays("");
        setAmount("");
        setPlayerType("");
        setPlayerCount("");
        setAvailableType("");
        setIsActive(false);

      } else {
        setCouponName(editData.title);
        setDescription(editData.description);
        setExpiryDate(moment(editData?.expiryDate).format("YYYY-MM-DD") || "");
        setStartTime(moment(editData?.start_date).format("YYYY-MM-DD") || "");
        setExpiryType(editData?.type_coupon);
        setExpiryDays(editData?.expiry_days);
        setAmount(editData?.amount);
        setPlayerType(editData?.player_type);
        setPlayerCount(editData?.player_count)
        setAvailableType(editData?.available_to);
        setIsActive(editData?.isActive || false);


      }
    }
  }, [editData, open]);

  const handleCancel = () => {
    onClose();
  };

  const handleAmountchange = (event) => {
    const value = event.target.value;
    
    if (value === '' || parseFloat(value) >= 1) {
      setAmount(value);
    }
  };

  const handleOk = () => {
    if (
      couponName &&
      description &&
      amount &&
      playerType &&
      startTime &&
      playerCount &&
      availableType
    ) {
      let url = editData?.id_coupon
        ? `${endPoints.api.UPDATE_COUPON}`
        : `${endPoints.api.CREATE_COUPON}`;

      let payload = {
        type_coupon: expiryType,
        title: couponName,
        description: description,
        amount: amount,
        expiry_days: expiryDays,
        expiryDate: expiryDate,
        player_count: playerCount,
        player_type: playerType,
        user_list: customerIds,
        available_to: availableType,
        start_date: startTime,
      //  end_date: startTime,
        isActive: isActive,

      };

      if (editData?.id_coupon) {
        payload.id_coupon = editData.id_coupon;
      }
      setIsLoading(true);
      addData(url, payload)
        .then((response) => {
          setIsLoading(false);
          if (response.data.status === "success") {
            SuccesToast(response?.data?.message);
            onClose();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
    } else {
      ErrorToast("all fields are required");
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const text = e.target.result;
      // Assuming the CSV contains only one column of customer IDs
      const idsArray = text.split("\n").map((row) => row.trim());
      const user_ids = idsArray.join(",");
      setCustomerIds(user_ids);
    };

    reader.readAsText(file);
  };

  return (
    <Dialog
      xl={{ "& .MuiDialog-paper": { width: "100%", maxHeight: 435 } }}
      maxWidth="sm"
      open={open}
      {...other}
    >
      <DialogTitle>Coupon Info </DialogTitle>

      <DialogContent dividers>
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Coupon Name"
            value={couponName}
            onChange={(event) => {
              setCouponName(event.target.value);
            }}
          />
        </FormControl>
        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Description"
            value={description}
            onChange={(event) => {
              setDescription(event.target.value);
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            id="demo-row-radio-buttons-group-label"
            style={{ marginTop: "20px" }}
          >
            Expiry Date/Days
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
          >
            <FormControlLabel
              value="1"
              checked={expiryType == "1" ? true : false}
              control={<Radio />}
              label="Expiry Date"
              onChange={() => {
                setExpiryType("1");
              }}
            />
            <FormControlLabel
              value="2"
              checked={expiryType == "2" ? true : false}
              control={<Radio />}
              label="Days"
              onChange={() => {
                setExpiryType("2");
              }}
            />
          </RadioGroup>
        </FormControl>

        {expiryType == "1" && (
          <FormControl style={{ width: "100%", marginTop: "20px" }}>
            <label> Expiry Date </label>
            <TextField
              id="filled-required"
              variant="outlined"
              type="date"
              value={expiryDate}
              onChange={(event) => {
                setExpiryDate(event.target.value);
              }}
            />
          </FormControl>
        )}

        {expiryType == "2" && (
          <FormControl style={{ width: "100%", marginTop: "20px" }}>
            <TextField
              id="filled-required"
              variant="outlined"
              label="No of days"
              value={expiryDays}
              onChange={(event) => {
                setExpiryDays(event.target.value);
              }}
            />
          </FormControl>
        )}

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>Start Date</label>
          <TextField
            id="filled-required"
            variant="outlined"
            placeholder="start date"
            type="date"
            value={startTime}
            onChange={(event) => {
              setStartTime(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Amount"
            type="number"
            value={amount}
            onChange={handleAmountchange}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            id="demo-row-radio-buttons-group-label"
            style={{ marginTop: "20px" }}
          >
            Team Player
          </FormLabel>
          <RadioGroup row name="row-radio-buttons-group">
            <FormControlLabel
              value="1"
              checked={playerType == "1" ? true : false}
              control={<Radio />}
              label="Fixed Team Size"
              onChange={() => {
                setPlayerType("1");
              }}
            />
            <FormControlLabel
              value="2"
              checked={playerType == "2" ? true : false}
              control={<Radio />}
              label="Min Team Size"
              onChange={() => {
                setPlayerType("2");
              }}
            />
          </RadioGroup>
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="No of Player"
            value={playerCount}
            onChange={(event) => {
              setPlayerCount(event.target.value);
            }}
          />
        </FormControl>
        <div>
          <FormControl>

         
         <FormControlLabel
          control={
            <Switch
              name="active"
              value={isActive}
              onClick={() => {
                setIsActive(!isActive);
              }}
              defaultChecked={isActive}
            />
          }
          labelPlacement="start"
          label="Active"
        />
         </FormControl>
        </div>
        

        <FormControl>
          <FormLabel
            id="demo-row-radio-buttons-group-label"
            style={{ marginTop: "20px" }}
          >
            Available to
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
          >
            <FormControlLabel
              value="1"
              checked={availableType == "1" ? true : false}
              control={<Radio />}
              label="List Based"
              onChange={() => {
                setAvailableType("1");
              }}
            />
            <FormControlLabel
              value="2"
              checked={availableType == "2" ? true : false}
              control={<Radio />}
              label="Webhook Triggered "
              onChange={() => {
                setAvailableType("2");
              }}
            />
          </RadioGroup>
        </FormControl>
        {availableType == "1" && (
          // <label style={{marginTop:"5px"}}>Upload User List</label>
          <Form.Control
            style={{ marginBottom: "20px", width: "100%" }}
            id="filled-required"
            variant="outlined"
            label="image"
            // value={image}
            name={userlist}
            type="file"
            onChange={handleFileUpload}
            accept=".csv"
          />
        )}
   
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateCoupon;
